import { useEffect } from 'react'

import { Fees, Space } from '../../../../../components/core-v2'
import { useAppSelector } from '../../../store/hooks'
import { useActions } from '../../../store/use-actions'
import { formatFees } from '../../../util'
import { StyledCharges } from '../../01-note/existing-note/details-summary/primitives'
import { actions as rawActions } from '../state/portfolio-slice'

const EconomicsDetailsSummary = () => {
  const builderState = useAppSelector(state => state.builder)
  const existingNoteState = useAppSelector(state => state.existingNote)
  const noteState = useAppSelector(state => state.note)
  const strategy = useAppSelector(state => state.strategy)
  const portfolioState = useAppSelector(state => state.portfolio)
  const actions = useActions(rawActions)

  let stratFees = []
  let portfolioFees = []

  const { savedState } = builderState
  const { pendingAccountState } = savedState.account
  const { currentAccountState } = savedState.account

  if (pendingAccountState && pendingAccountState.strategyOverrideFees) {
    stratFees = formatFees(pendingAccountState.strategyOverrideFees)
  } else if (
    pendingAccountState &&
    pendingAccountState.strategy &&
    pendingAccountState.strategy.fees
  ) {
    stratFees = formatFees(pendingAccountState.strategy.fees)
  } else if (
    pendingAccountState &&
    pendingAccountState.strategy &&
    pendingAccountState.strategyTemplateId
  ) {
    if (
      strategy &&
      strategy.strategyFees &&
      strategy.selectedStrategy.id &&
      strategy.strategyFees[strategy.selectedStrategy.id]
    ) {
      stratFees = strategy.strategyFees[strategy.selectedStrategy.id]
    }
  } else if (
    currentAccountState &&
    currentAccountState.strategy &&
    currentAccountState.strategy.fees
  ) {
    stratFees = formatFees(currentAccountState.strategy.fees)
  }

  if (pendingAccountState && pendingAccountState.portfolioOverrideFees) {
    portfolioFees = pendingAccountState.portfolioOverrideFees
  } else if (
    pendingAccountState &&
    pendingAccountState.portfolio &&
    pendingAccountState.portfolio.fees
  ) {
    portfolioFees = pendingAccountState.portfolio.fees
  } else if (savedState.currentPortfolio && savedState.currentPortfolio.fees) {
    portfolioFees = savedState.currentPortfolio.fees
  } else {
    portfolioFees = savedState.client.defaultFees.defaultPortfolioFees
  }

  useEffect(() => {
    if (noteState) {
      const { note } = noteState
      actions.init(note)
    }
  }, [actions, noteState, noteState.note])

  return (
    <Space fontSize="13px" mx={5} my={6}>
      {existingNoteState.fees && (
        <Space my={4}>
          <StyledCharges>
            <Fees fees={existingNoteState.fees} title="Note charge" />
          </StyledCharges>
        </Space>
      )}

      {portfolioState?.model?.fees && (
        <Space my={4}>
          <StyledCharges>
            <Fees fees={formatFees(portfolioFees)} title="Portfolio charge" />
          </StyledCharges>
        </Space>
      )}

      {stratFees && stratFees.length > 0 && (
        <Space my={4}>
          <StyledCharges>
            <Fees fees={stratFees} title="Strategy charge" />
          </StyledCharges>
        </Space>
      )}
    </Space>
  )
}

export default EconomicsDetailsSummary
